import React from "react";

export default function TextSizeControl({ value, onChange, className = "", style }) {
  const min = 20;
  const max = 80;
  const pct = Math.max(0, Math.min(100, ((Number(value) - min) / (max - min)) * 100));
  return (
    <label className={`lrp-inline-label ${className}`.trim()} style={{ gap: 10, ...(style || {}) }}>
      <span style={{ fontSize: 16, opacity: 0.9 }}>Text size</span>
      <input
        className="lrp-range"
        type="range"
        min={min}
        max={max}
        step={2}
        value={value}
        style={{ '--lrp-range-pct': `${pct}%` }}
        onChange={(e) => onChange?.(Number(e.target.value))}
        aria-label="Teleprompter text size in pixels"
      />
      <span style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}>{value}px</span>
    </label>
  );
}
